export default __webpack_public_path__ + "static/media/HRA0201_Pharmacy_guide_ Menstrual_Diagram.478f5240.pdf";